import React, {useState} from 'react';
import {ArrowPosition, MenuItem, Popover} from '@bosch/react-frok';
import {t} from 'i18next';
import {AddButton, PopoverMenuWrapper} from './AddItemMenu.style';
import {generateIdentifier} from '../../utils/IdentityUtils';
import {TemplatePropertySettings} from '../../models/TemplatePropertySettings';
import {isVisibleComponent} from '../../utils/TemplateUtils';
import {
    ADD_ITEM_MENU_MAIN_ACTION_CREATE_FOLDER,
    ADD_ITEM_MENU_MAIN_ACTION_UPLOAD_FILE,
    ADD_ITEM_MENU_MOBILE_MAIN_ACTION_CREATE_FOLDER,
    ADD_ITEM_MENU_MOBILE_MAIN_ACTION_UPLOAD_FILE,
    DOWNLOAD_CENTER_MAIN_ACTION,
    DOWNLOAD_CENTER_MOBILE_MAIN_ACTION
} from '../../init/ui_component_constants';
import {executeAction} from '../../utils';

export interface AddItemDialogProps {
    readonly templatePropertySettings: Map<string, TemplatePropertySettings>;
    readonly isMobileView: boolean;
    onCreateFolderClicked: () => void;
    onUploadFileClicked: () => void;
}

/**
 * @name AddItemMenu
 * @description
 * Component to open a popover in the search/filter bar to add files or folders when click on add (+).
 */
export const AddItemMenu: React.VFC<AddItemDialogProps> = (props) => {
    if (!(isVisibleComponent(DOWNLOAD_CENTER_MAIN_ACTION, props.templatePropertySettings)
        && ((!props.isMobileView) || (props.isMobileView && isVisibleComponent(DOWNLOAD_CENTER_MOBILE_MAIN_ACTION, props.templatePropertySettings))))) {
        return null;
    }

    const [isOpen, setIsOpen] = useState<boolean>(false);
    const toggle = () => {
        setIsOpen(!isOpen);
        document.body.click();
    };

    return (
        <PopoverMenuWrapper id={generateIdentifier()}>
            <Popover id={generateIdentifier()}
                     open={isOpen}
                     position={ArrowPosition.BOTTOM_CENTER}
                     onCloseButtonClick={toggle}
                     onCloseKeyPressed={toggle}
                     onOutsideClick={toggle}
                     onTriggerClick={toggle}
                     content={
                         <ul id={generateIdentifier()}
                             hidden={!((isVisibleComponent(ADD_ITEM_MENU_MAIN_ACTION_CREATE_FOLDER, props.templatePropertySettings)
                                     && ((!props.isMobileView) || (props.isMobileView && isVisibleComponent(ADD_ITEM_MENU_MOBILE_MAIN_ACTION_CREATE_FOLDER, props.templatePropertySettings))))
                                 || (isVisibleComponent(ADD_ITEM_MENU_MAIN_ACTION_UPLOAD_FILE, props.templatePropertySettings)
                                     && ((!props.isMobileView) || (props.isMobileView && isVisibleComponent(ADD_ITEM_MENU_MOBILE_MAIN_ACTION_UPLOAD_FILE, props.templatePropertySettings)))))}
                             className='a-list o-context-menu__menuItems'>
                             {(isVisibleComponent(ADD_ITEM_MENU_MAIN_ACTION_CREATE_FOLDER, props.templatePropertySettings)
                                     && ((!props.isMobileView) || (props.isMobileView && isVisibleComponent(ADD_ITEM_MENU_MOBILE_MAIN_ACTION_CREATE_FOLDER, props.templatePropertySettings)))) &&
                                 <MenuItem id={generateIdentifier()}
                                           key='folder'
                                           icon='folder-open'
                                           label={t('ADD_ITEM_MENU_COMPONENT_FOLDER_LABEL')}
                                           onClick={() => {
                                               toggle();
                                               props.onCreateFolderClicked();
                                           }}/>
                             }
                             {(isVisibleComponent(ADD_ITEM_MENU_MAIN_ACTION_UPLOAD_FILE, props.templatePropertySettings)
                                     && ((!props.isMobileView) || (props.isMobileView && isVisibleComponent(ADD_ITEM_MENU_MOBILE_MAIN_ACTION_UPLOAD_FILE, props.templatePropertySettings)))) &&
                                 <MenuItem id={generateIdentifier()}
                                           key='file'
                                           icon='document'
                                           label={t('ADD_ITEM_MENU_COMPONENT_FILE_LABEL')}
                                           onClick={() => {
                                               toggle();
                                               props.onUploadFileClicked();
                                           }}/>
                             }
                         </ul>
                     }
                     trigger={
                         <AddButton id={generateIdentifier()}
                                    key='add'
                                    icon='add'
                                    mode='secondary'
                                    title={t('ADD_ITEM_MENU_COMPONENT_LABEL')}
                                    onClick={(e) => executeAction(e, toggle)}/>
                     }
            />
        </PopoverMenuWrapper>
    );
};
